import './RefinanciarWizard.scss';

import React, { useState } from 'react';

import { useFeatureFlags } from '../../context/FeatureFlagsContext';
import StepNav from '../../components/stepnav/StepNav';
import FormContacto from './FormContacto';
import InfoCredito from './InfoCredito';
import ConDetalle from './ConDetalle';

const RefinanciarWizard = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const { flags, isLoadingFlags } = useFeatureFlags();
  const isOnlyInDetail = !isLoadingFlags && flags.isOnlyInDetail;

  const steps = [
    { id: 1, label: 'Info de contacto', component: FormContacto },
    { id: 2, label: 'Info del crédito', component: isOnlyInDetail ? ConDetalle : InfoCredito },
  ];

  const totalSteps = steps.length;

  const handleStepChange = (stepId) => {
    setCurrentStep(stepId);
  };

  const handleNextStep = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newData,
      typeFinancing: 'refinanciamiento',
      type: 'CF',
    }));
    if (currentStep < totalSteps) {
      handleStepChange(currentStep + 1);
    }
  };

  const handlePreviousStep = (newData) => {
    if (newData) {
      setFormData((prevData) => ({
        ...prevData,
        ...newData,
      }));
    }
    if (currentStep > 1) {
      handleStepChange(currentStep - 1);
    }
  };

  const StepComponent = steps.find((step) => step.id === currentStep).component;

  return (
    <div className="financiar-wizard-container">
      <StepNav steps={steps} currentStep={currentStep} totalSteps={totalSteps} />
      <>
        <StepComponent
          onNextStep={handleNextStep}
          onPreviousStep={handlePreviousStep}
          data={formData}
        />
      </>
    </div>
  );
};

export default RefinanciarWizard;
